import Icon from 'app/components/Icon'
import React, { InputHTMLAttributes, useContext, useEffect } from 'react'
import { ErrorGroupContext } from './ErrorGroup'
import { FormContext } from './Form'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string | any
    name: string
    labelClassName?: string
    wraperClassName?: string
    noCheck?:boolean
    clearSelection?:boolean
    icon?:string
}

function TextField(props: Props) {
    const { label, className, name, labelClassName, noCheck = false, wraperClassName, icon, clearSelection = false, ...rest } = props

    const { data, setData, errors, clearErrors } = useContext(FormContext)
    const {seterrors} = useContext(ErrorGroupContext);
    useEffect(() => {
        seterrors( e => ({...e, [name]: errors[name]   }) )
    }, [errors[name]])

    return (
        <label className={("w-full relative flex flex-col box-border ") + (wraperClassName)}>
            <div className={("text-white mb-8px ") + labelClassName}>{label}</div>
            {
                icon&&
                <Icon className={`w-20px absolute left-16px cursor-pointer text-pink mt-15px`} name={icon} />
            }
            <input
                className={`border ${errors[name] ? "border-red" : "border-gray-darker"}  rounded bg-gray-darker text-white  placeholder-white placeholder-opacity-60 text-14 h-55px flex box-border w-full items-center px-19px ${icon&&"pl-45px"} outline-none ${className}`}
                type="text"
                {...rest}
                name={name}
                value={data[name] ?? ""}
                onChange={e => { setData(name, e.target.value); clearErrors(name) }}
            />
            {/* {
                (data[name]?.length > 0 && !noCheck) &&
                <div className={(`bg-green absolute top-0 right-0 ${label?"mt-40px":"mt-20px"}  mr-13px rounded-full w-22px h-22px flex justify-center items-center text-white`)}>
                    <Icon name="tick" />
                </div>
            } */}
            {
                (data[name]?.length > 0 && clearSelection && noCheck) &&
                <div onClick={()=>setData(name, '')} className={(`absolute cursor-pointer top-0 right-0 ${label?"mt-40px":"mt-20px"}  mr-13px rounded-full w-22px h-22px flex justify-center items-center`)}>
                    <Icon name="cross" />
                </div>
            }
            <div className={`h-12px text-12 mt-4px text-C86B28 leading-none ${errors[name] ? "" : "opacity-0"}`}>{errors?.[name]}</div>
        </label>
    )
}

export default TextField
